export function removeCSSClass(ele, cls) {
  const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
  ele.className = ele.className.replace(reg, ' ')
}

export function addCSSClass(ele, cls) {
  ele.classList.add(cls)
}

export const toAbsoluteUrl = pathname => process.env.PUBLIC_URL + pathname

export function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      // const {
      //   auth: { authToken }
      // } = store.getState()

      const authToken = window.localStorage.getItem('token')

      if (authToken) {
        // config.headers.Authorization = `Bearer ${authToken}`
        config.headers.Authorization = `${authToken}`
      }

      return config
    },
    err => Promise.reject(err)
  )

  axios.interceptors.response.use(
    success => {
      return success
    },
    ({ response }) => {
      if (response) {
        let errorMessage = ''
        switch (response.status) {
          case 400:
            errorMessage = response.data === 'Bad Request' ? 'La tarea solicitada no se ha completado.' : response.data.error
            break
          case 404:
            errorMessage = response.data === 'Not Found' ? 'No se ha encontrado el recurso solicitado.' : response.data.error
            break
          case 409:
            errorMessage = response.data === 'Conflict' ? 'Ha ocurrido un error de duplicidad en la petición.' : response.data.error
            break
          case 500:
            errorMessage = response.data === 'Internal Server Error' ? 'Ha ocurrido un error en el servidor.' : response.data.error
            break
          default:
            errorMessage = 'Ha ocurrido un error en el servidor.'
        }

        response.data = {
          ...response.data,
          error: errorMessage
        }
      }
      return Promise.reject(response)
    }
  )
}

export function setupNestAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const authToken = window.localStorage.getItem('token')

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`
      }

      const ioId = window.localStorage.getItem('ioid')
      if (ioId) {
        config.headers['x-clientid'] = ioId
      }

      return config
    },
    err => Promise.reject(err)
  )

  axios.interceptors.response.use(
    success => {
      return success
    },
    async ({ response }) => {
      if (response) {
        let errorMessage = ''
        if (response.status === 400 || response.status === 404 || response.status === 409 || response.status === 500) {
          if (response.request.responseType === 'blob') {
            let resData = null
            try {
              let resText = await new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.addEventListener('abort', reject)
                reader.addEventListener('error', reject)
                reader.addEventListener('loadend', () => {
                  resolve(reader.result)
                })
                reader.readAsText(response.data)
              })
              resData = JSON.parse(resText) // <--- try to parse as json evantually
            } catch (err) {
              // ignore
            }

            switch (response.status) {
              case 400:
                errorMessage = resData.message || 'La tarea solicitada no se ha completado.'
                break
              case 404:
                errorMessage = resData.message || 'No se ha encontrado el recurso solicitado.'
                break
              case 409:
                errorMessage = resData.message || 'Ha ocurrido un error de duplicidad en la petición.'
                break
              case 500:
                errorMessage = resData.message || 'Ha ocurrido un error en el servidor.'
                break
              default:
                errorMessage = 'Ha ocurrido un error en el servidor.'
            }
          } else {
            switch (response.status) {
              case 400:
                errorMessage = response.data === 'Bad Request' ? 'La tarea solicitada no se ha completado.' : response.data.message
                break
              case 404:
                errorMessage = response.data === 'Not Found' ? 'No se ha encontrado el recurso solicitado.' : response.data.message
                break
              case 409:
                errorMessage = response.data === 'Conflict' ? 'Ha ocurrido un error de duplicidad en la petición.' : response.data.message
                break
              case 500:
                errorMessage = response.data === 'Internal Server Error' ? 'Ha ocurrido un error en el servidor.' : response.data.message
                break
              default:
                errorMessage = 'Ha ocurrido un error en el servidor.'
            }
          }
        }

        response.data = {
          ...response.data,
          error: errorMessage
        }
      }
      return Promise.reject(response)
    }
  )
}

export function setupContaAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const authToken = window.localStorage.getItem('token')

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`
      }

      const ioId = window.localStorage.getItem('ioid')
      if (ioId) {
        config.headers['x-clientid'] = ioId
      }

      return config
    },
    err => Promise.reject(err)
  )

  axios.interceptors.response.use(
    success => {
      return success
    },
    async ({ response }) => {
      if (response) {
        let errorMessage = ''
        if (response.status === 400 || response.status === 404 || response.status === 409 || response.status === 500) {
          if (response.request.responseType === 'blob') {
            let resData = null
            try {
              let resText = await new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.addEventListener('abort', reject)
                reader.addEventListener('error', reject)
                reader.addEventListener('loadend', () => {
                  resolve(reader.result)
                })
                reader.readAsText(response.data)
              })
              resData = JSON.parse(resText) // <--- try to parse as json evantually
            } catch (err) {
              // ignore
            }

            switch (response.status) {
              case 400:
                errorMessage = resData.message || 'La tarea solicitada no se ha completado.'
                break
              case 404:
                errorMessage = resData.message || 'No se ha encontrado el recurso solicitado.'
                break
              case 409:
                errorMessage = resData.message || 'Ha ocurrido un error de duplicidad en la petición.'
                break
              case 500:
                errorMessage = resData.message || 'Ha ocurrido un error en el servidor.'
                break
              default:
                errorMessage = 'Ha ocurrido un error en el servidor.'
            }
          } else {
            switch (response.status) {
              case 400:
                errorMessage = response.data === 'Bad Request' ? 'La tarea solicitada no se ha completado.' : response.data.message
                break
              case 404:
                errorMessage = response.data === 'Not Found' ? 'No se ha encontrado el recurso solicitado.' : response.data.message
                break
              case 409:
                errorMessage = response.data === 'Conflict' ? 'Ha ocurrido un error de duplicidad en la petición.' : response.data.message
                break
              case 500:
                errorMessage = response.data === 'Internal Server Error' ? 'Ha ocurrido un error en el servidor.' : response.data.message
                break
              default:
                errorMessage = 'Ha ocurrido un error en el servidor.'
            }
          }
        }

        response.data = {
          ...response.data,
          error: errorMessage
        }
      }
      return Promise.reject(response)
    }
  )
}

export function setupAkdemicAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      const authToken = window.localStorage.getItem('akdemicToken')

      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`
      }

      const ioId = window.localStorage.getItem('ioid')
      if (ioId) {
        config.headers['x-clientid'] = ioId
      }

      return config
    },
    err => Promise.reject(err)
  )

  axios.interceptors.response.use(
    success => {
      return success
    },
    async ({ response }) => {
      if (response) {
        let errorMessage = ''
        if (response.status === 400 || response.status === 404 || response.status === 409 || response.status === 500) {
          if (response.request.responseType === 'blob') {
            let resData = null
            try {
              let resText = await new Promise((resolve, reject) => {
                let reader = new FileReader()
                reader.addEventListener('abort', reject)
                reader.addEventListener('error', reject)
                reader.addEventListener('loadend', () => {
                  resolve(reader.result)
                })
                reader.readAsText(response.data)
              })
              resData = JSON.parse(resText) // <--- try to parse as json evantually
            } catch (err) {
              // ignore
            }

            switch (response.status) {
              case 400:
                errorMessage = resData.message || 'La tarea solicitada no se ha completado.'
                break
              case 404:
                errorMessage = resData.message || 'No se ha encontrado el recurso solicitado.'
                break
              case 409:
                errorMessage = resData.message || 'Ha ocurrido un error de duplicidad en la petición.'
                break
              case 500:
                errorMessage = resData.message || 'Ha ocurrido un error en el servidor.'
                break
              default:
                errorMessage = 'Ha ocurrido un error en el servidor.'
            }
          } else {
            switch (response.status) {
              case 400:
                errorMessage = response.data === 'Bad Request' ? 'La tarea solicitada no se ha completado.' : response.data.message
                break
              case 404:
                errorMessage = response.data === 'Not Found' ? 'No se ha encontrado el recurso solicitado.' : response.data.message
                break
              case 409:
                errorMessage = response.data === 'Conflict' ? 'Ha ocurrido un error de duplicidad en la petición.' : response.data.message
                break
              case 500:
                errorMessage = response.data === 'Internal Server Error' ? 'Ha ocurrido un error en el servidor.' : response.data.message
                break
              default:
                errorMessage = 'Ha ocurrido un error en el servidor.'
            }
          }
        }

        response.data = {
          ...response.data,
          error: errorMessage
        }
      }
      return Promise.reject(response)
    }
  )
}

export function removeStorage(key) {
  try {
    localStorage.setItem(key, '')
    localStorage.setItem(key + '_expiresIn', '')
  } catch (e) {
    console.log('removeStorage: Error removing key [' + key + '] from localStorage: ' + JSON.stringify(e))
    return false
  }
  return true
}

/*  getStorage: retrieves a key from localStorage previously set with setStorage().
    params:
        key <string> : localStorage key
    returns:
        <string> : value of localStorage key
        null : in case of expired key or failure
 */
export function getStorage(key) {
  const now = Date.now() //epoch time, lets deal only with integer
  // set expiration for storage
  let expiresIn = localStorage.getItem(key + '_expiresIn')
  if (expiresIn === undefined || expiresIn === null) {
    expiresIn = 0
  }

  expiresIn = Math.abs(expiresIn)
  if (expiresIn < now) {
    // Expired
    removeStorage(key)
    return null
  } else {
    try {
      const value = localStorage.getItem(key)
      return value
    } catch (e) {
      console.log('getStorage: Error reading key [' + key + '] from localStorage: ' + JSON.stringify(e))
      return null
    }
  }
}
/*  setStorage: writes a key into localStorage setting a expire time
    params:
        key <string>     : localStorage key
        value <string>   : localStorage value
        expires <number> : number of seconds from now to expire the key
    returns:
        <boolean> : telling if operation succeeded
 */
export function setStorage(key, value, expires) {
  if (expires === undefined || expires === null) {
    expires = 24 * 60 * 60 // default: seconds for 1 day
  }

  const now = Date.now() //millisecs since epoch time, lets deal only with integer
  const schedule = now + expires * 1000
  try {
    localStorage.setItem(key, value)
    localStorage.setItem(key + '_expiresIn', schedule)
  } catch (e) {
    console.log('setStorage: Error setting key [' + key + '] in localStorage: ' + JSON.stringify(e))
    return false
  }
  return true
}
